import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { AppUser } from 'src/app/shared/models/app-user';
import { InsightsLibraryActions, InsightsLibraryDashboard, InsightsLibrarySelectors, InsightsLibraryVisual } from '../../state/insights-library';
import { InsightsLibraryComponent } from '../insights-library/insights-library.component';
import { AppCurrencyService } from 'src/app/app/AppCurrencyService';
import { VisualFieldTargetResolver } from 'src/app/pbir/visuals/VisualFieldTargetResolver';
import { DataFormatter } from 'src/app/pbir/formatting/DataFormatter';
import { FilterUtils } from 'src/app/pbir/utils/FilterUtils';

@Component({
  selector: 'app-insights-library__dashboards',
  templateUrl: './dashboards.component.html',
  styleUrls: ['./dashboards.component.scss'],
  standalone: false
})
export class InsightsLibraryDashboardsComponent {
  readonly insightsLibrary = inject(InsightsLibraryComponent);
  readonly currencyService = inject(AppCurrencyService);

  @Input() user: AppUser;
  @Input() busy = false;

  @Output() categorySelected = new EventEmitter<any>();
  @Output() itemSelected = new EventEmitter<any>();

  @Output('favourite') _favourite = new EventEmitter<InsightsLibraryDashboard>();
  @Output('view') _view = new EventEmitter<InsightsLibraryDashboard>();
  @Output('copyDashboard') _copy = new EventEmitter<InsightsLibraryDashboard>();
  @Output('toggleHome') _toggleHome = new EventEmitter<InsightsLibraryDashboard>();

  itemSelectorActions = InsightsLibraryActions.dashboardItemSelector;
  itemSelectorSelectors = InsightsLibrarySelectors.dashboardItemSelector;

  constructor() {
  }


  favourite(item: InsightsLibraryDashboard) {
    this._favourite.emit(item);
  }

  view(item: InsightsLibraryDashboard) {
    this._view.emit(item);
  }

  copy(item: InsightsLibraryDashboard) {
    this._copy.emit(item);
  }

  toggleHome(item: InsightsLibraryDashboard) {
    this._toggleHome.emit(item);
  }

  formatFilter(item: InsightsLibraryDashboard, index: number) {
    let m = this.insightsLibrary.dataModel();
    if (!m)
      return '';

    let filter = item.filters[index] as any;

    return filter.__filterDesc ??= (() => {
      let currencies = this.currencyService.currencies();

      let fieldResolver = VisualFieldTargetResolver.create({
        currencies,
        dataModel: m,
      });
      
      let dataFormatter = DataFormatter.createDefault({ currencies });
      return new FilterUtils.Formatter(fieldResolver, dataFormatter).formatDescription(filter, {
        capitalizeFirstWord: true,
        noHtml: false
      });
    })();
  }
}
